import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { t } from 'Src/i18n';
import { isSeller } from 'Utils/seller/sellerUtils';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  proposal: Proposal;
  title: string;
};
export const AlternativePriceTitle = ({ className, proposal: { price }, title }: Props) => {
  const appContext = useAppContext();

  if (!price) {
    return null;
  }

  return (
    <h2
      className={classnames(
        'flex items-center gap-10 text-24 font-bold leading-tight text-orange md:text-28 lg:text-32',
        className,
      )}
    >
      {(isSeller(appContext) && price.gap >= 30) || price.gap < 30 ? (
        <Fragment>
          <Icon hasRtl name={ICONS.LIGHTBULB} width="1em" />
          {title}
        </Fragment>
      ) : (
        <Fragment>
          <Icon hasRtl name={ICONS.LIGHTBULB} width="4rem" />
          {t('booking.counterProposalPopIn.callCenterAdvise')}
          <span className="flex items-center gap-5 text-18">
            <Icon hasRtl name={ICONS.PHONE_BUBBLE} width="4rem" />
            <span>
              <span>{t('booking.counterProposalPopIn.pleaseCallLabel')}</span>{' '}
              {t('travelAdvisor.phoneNumber')}{' '}
              <span className="text-16 text-black">
                {t('booking.counterProposalPopIn.callCost')}
              </span>
            </span>
          </span>
        </Fragment>
      )}
    </h2>
  );
};
